import { getLanguage } from 'azure-maps-control';
import { ApiControllerActionEnum } from 'src/app/models/enums/ApiControllerActionEnum';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiUrl = environment.apiUrl;
    const angularServer = environment.angularServer;

    if (request.url.includes('http')) { //Access resource outside the enviroment e.g googleAPI

    }
    else if (request.url.includes('assets/i18n')) {
      request = request.clone({
        url: angularServer + request.url

      });
    }
    else if(request.url.includes('uploadFile')){
    //Todo: Add Auth TO Upload File , this causing issue when put the clone
    request = request.clone({
      url: apiUrl + request.url
    });
    }
    else if(request.url.includes('image')){
      //Todo: Add Auth TO Upload File , this causing issue when put the clone
      request = request.clone({
        url: apiUrl + request.url
      });
      }
      else if(request.url.includes(ApiControllerActionEnum.GetLanguages) || request.url.includes(ApiControllerActionEnum.GetMyContent) || request.url.includes(ApiControllerActionEnum.GetCurrencies)){
        request = request.clone({
          url: apiUrl + request.url
        });
      }
    else {
      if (this.auth.getToken()) {

        
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${this.auth.getToken()}`,
              'Content-Type':  'application/json'

            },

            url: apiUrl + request.url

          });
      }
      else {
        request = request.clone({
          setHeaders: {
            'Content-Type': 'application/json'
          },
          url: apiUrl + request.url
        });
      }
    }


    return next.handle(request);
  }
}
